"use client"
import * as React from "react"
import { Typography, Box } from "@mui/material"

export default function Logo() {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'left',
                alignItems: 'center',
                width: '100%'
            }}
        >
            <Typography
                variant="h5"
                sx={{
                    fontWeight: 'bold',
                    color: theme => theme.palette.primary.main,
                    cursor: 'pointer'
                }}
            >
                ProjectHub
            </Typography>
        </Box>
    )
}
